const translations = {
  en: {
    title: 'How to fill the visit routines CSV file',
    summary:
      'Updated instructions for downloading the latest file '
      + 'and filling the CSV used to register visit routines.',
    category: 'Database management',
    tags: ['CSV', 'visit_routines', 'Visit routines'] as string[],
    hero:
      'Use this guide to download the latest file, keep '
      + 'the CSV aligned with the current database data, '
      + 'and fill the fields required for visit routines.',
    generalRulesTitle: 'Before registering visits via CSV',
    generalRulesItem1: 'Click the Database menu.',
    generalRulesItem2: 'Click the Tables submenu.',
    generalRulesItem3: 'Click the visit_routines option.',
    generalRulesItem4: 'Click the "download latest update" button.',
    generalRulesItem5:
      'Then click the "Generate new file" button. This '
      + 'ensures the data remains updated with the '
      + 'information saved in the database.',
    generalRulesItem6: 'Download the latest processed file.',
    fieldsTitle: 'Fields to be filled',
    fieldsItem1: 'Customer code: enter the customer code.',
    fieldsItem2: 'Salesperson code: enter the salesperson code.',
    fieldsItem3:
      'Periodicity: this field defines the visit '
      + 'frequency. In the CSV, choose the code according '
      + 'to the desired frequency:',
    periodicityTableHeader1: 'Code',
    periodicityTableHeader2: 'Periodicity',
    periodicityDaily: 'Daily',
    periodicityWeekly: 'Weekly',
    periodicityBiweekly: 'Biweekly',
    periodicityMonthly: 'Monthly',
    fieldsItem4:
      'Day of week: choose the weekday on which the visit '
      + 'should start. In the CSV, describe it according '
      + 'to the table below:',
    weekdayTableHeader: 'Day of week',
    weekdayMonday: 'monday',
    weekdayTuesday: 'tuesday',
    weekdayWednesday: 'wednesday',
    weekdayThursday: 'thursday',
    weekdayFriday: 'friday',
    weekdaySaturday: 'saturday',
    weekdaySunday: 'sunday',
    fieldsItem5:
      'Start date: enter the date and time when the visit '
      + 'should start using the format yyyy-mm-dd hh:mm. '
      + 'Example: 2026-03-01 08:00.',
    fieldsItem6:
      'VlrMetaVenda, Obs, id, created_at, and updated_at do '
      + 'not need to be filled.',
  },
  pt: {
    title: 'Como preencher o arquivo CSV de rotinas de visitas',
    summary:
      'Instruções atualizadas para baixar o último arquivo '
      + 'processado e preencher o CSV usado no cadastro de '
      + 'rotinas de visitas.',
    category: 'Gerenciamento de banco de dados',
    tags: ['CSV', 'visit_routines', 'Rotinas de visitas'] as string[],
    hero:
      'Use este guia para baixar o arquivo mais recente, '
      + 'manter o CSV alinhado com os dados atuais do banco '
      + 'e preencher os campos necessários para as rotinas '
      + 'de visitas.',
    generalRulesTitle: 'Antes de realizar o cadastro das visitas via CSV',
    generalRulesItem1: 'Clique no menu Banco de dados.',
    generalRulesItem2: 'Clique no submenu Tabelas.',
    generalRulesItem3: 'Clique na opção visit_routines.',
    generalRulesItem4: 'Clique no botão "baixar última atualização".',
    generalRulesItem5:
      'Em seguida, clique no botão "Gerar novo arquivo". '
      + 'Com esse procedimento, garante-se que os dados '
      + 'estarão sempre atualizados com as informações '
      + 'gravadas no banco de dados.',
    generalRulesItem6: 'Realize o download do último arquivo processado.',
    fieldsTitle: 'Campos a serem preenchidos',
    fieldsItem1: 'Código do cliente: informar o código do cliente.',
    fieldsItem2: 'Código do vendedor: informar o código do vendedor.',
    fieldsItem3:
      'Periodicidade: está relacionada à frequência da '
      + 'visita. Para cadastro no CSV, escolha o código '
      + 'de acordo com a frequência desejada:',
    periodicityTableHeader1: 'Código',
    periodicityTableHeader2: 'Periodicidade',
    periodicityDaily: 'Diário',
    periodicityWeekly: 'Semanal',
    periodicityBiweekly: 'Quinzenal',
    periodicityMonthly: 'Mensal',
    fieldsItem4:
      'Dia da semana: escolha o dia da semana em que a '
      + 'visita deverá iniciar. Para cadastro no CSV, '
      + 'descreva conforme a tabela abaixo:',
    weekdayTableHeader: 'Dia da semana',
    weekdayMonday: 'segunda',
    weekdayTuesday: 'terca',
    weekdayWednesday: 'quarta',
    weekdayThursday: 'quinta',
    weekdayFriday: 'sexta',
    weekdaySaturday: 'sabado',
    weekdaySunday: 'domingo',
    fieldsItem5:
      'Data de início: informe a data e a hora em que a '
      + 'visita deve iniciar no formato '
      + 'aaaa-mm-dd hh:mm. Exemplo: 2026-03-01 08:00.',
    fieldsItem6:
      'VlrMetaVenda, Obs, id, created_at e updated_at não precisam ser preenchidos.',
  },
};

export default translations;
